module.exports = __webpack_public_path__ + "img/user.bffcaa25.svg";